import apiConnector from '@/epersonam/apiConnector';
import errorManager from '@/rollbar.js';

const getSelectValues = (select) => {
  let result = [];
  const options = select && select.options;
  let opt;

  for (let i = 0, iLen = options.length; i < iLen; i++) {
    opt = options[i];

    if (opt.selected) {
      result.push(opt.value || opt.text);
    }
  }
  return result;
};

const createSelectOptions = (select, options) => {
  for (let option of options) {
    let optionElement = document.createElement('option');
    optionElement.value = option.value;
    optionElement.text = option.text;
    select.appendChild(optionElement);
  }
};
const cleanElement = (ckeck, select) => {
  ckeck.disabled = true;
  ckeck.checked = false;
  select.classList.add('hide');
};

const calcActivitiesConfig = (baseSelector) => {
  if (!baseSelector) return;
  const baseUrl = `${window.config.ePersonamService.ePersonamHost}/${window.locale}`;
  const activitiesConfigUrl = `${baseUrl}/activities_configs/activities_configs_in_areas.json`;
  const selectActivities = document.querySelector(`${baseSelector} #grp_activities_values`);
  const activitiesConfigInput = document.querySelector(`${baseSelector}  #grp_activities_config_values `);
  const subActivitiesInput = document.querySelector(`${baseSelector} #grp_sub_activities_values`);

  const ckeckActivities = document.querySelector(`${baseSelector} #activities`);

  const ckeckActivitiesConfig = document.querySelector(`${baseSelector} #activities_config`);
  const activitiesConfigSelect = document.querySelector(`${baseSelector} .activities_config_select`);

  const ckeckSubActivitiesConfig = document.querySelector(`${baseSelector} #sub_activities`);
  const subActivitiesConfigSelect = document.querySelector(`${baseSelector} .sub_activities_select`);

  ckeckActivities.onchange = (event) => {
    if (event?.currentTarget.checked) {
      ckeckActivitiesConfig.disabled = false;
    } else {
      cleanElement(ckeckActivitiesConfig, activitiesConfigSelect);
      cleanElement(ckeckSubActivitiesConfig, subActivitiesConfigSelect);
    }
  };

  ckeckActivitiesConfig.onchange = (event) => {
    if (event?.currentTarget.checked) {
      ckeckSubActivitiesConfig.disabled = false;
    } else {
      cleanElement(ckeckSubActivitiesConfig, subActivitiesConfigSelect);
    }
  };

  selectActivities.onchange = (event) => {
    activitiesConfigInput.innerHTML = '';
    subActivitiesInput.innerHTML = '';

    if (event?.currentTarget?.value) {
      const selVals = getSelectValues(selectActivities);
      let subActivities = [];
      apiConnector()
        .get(`${activitiesConfigUrl}`, { params: { area_id: selVals } })
        .then((response) => {
          for (let el of response.data) {
            if (!el) continue;

            let optionElement = document.createElement('option');
            optionElement.value = el.value;
            optionElement.text = el.text;
            if (el.sub_activities?.length) {
              subActivities = [...subActivities, ...el.sub_activities];
            }
            activitiesConfigInput.appendChild(optionElement);
          }

          selectActivities.allSubActivities = subActivities;
          createSelectOptions(subActivitiesInput, subActivities);
        });
    }
  };

  activitiesConfigInput.onchange = (event) => {
    subActivitiesInput.innerHTML = '';
    ckeckSubActivitiesConfig.disabled = false;
    if (event?.currentTarget?.value) {
      const allSubActivities = selectActivities.allSubActivities;
      const selActivitiesVals = getSelectValues(activitiesConfigInput);
      const subActivitiesOptions = allSubActivities.filter((oggetto) => selActivitiesVals.includes(`${oggetto.activity_config_id}`));
      createSelectOptions(subActivitiesInput, subActivitiesOptions);
      if (!subActivitiesOptions.length) {
        cleanElement(ckeckSubActivitiesConfig, subActivitiesConfigSelect);
      }
    }
  };
};

const init = (baseSelector) => {
  try {
    calcActivitiesConfig(baseSelector);
  } catch (e) {
    errorManager(e);
  }
};

window.GrpActivities = {
  init: init,
};
